/* =========================================
StudentTcSession.jsx
========================================= */

import React, {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const StudentTcSession = () => {
  const [open, setOpen] =
    useState(false);

  const [classes, setClasses] =
    useState([]);

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  useEffect(() => {
    fetch(
      `https://njinternational.ilakshyaerp.in/api/student-tc/classes/${id}`
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setClasses(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, [id]);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      <div className="container">

        <div className="gallery-section">
          <h2 className="gallery-title">
            Classes
          </h2>
        </div>

        <div className="life-grid">

          {classes.map(
            (item) => (
              <div
                key={item.id}
                className="life-card"
                onClick={() =>
                  navigate(
                    `/student-tc/class/${item.id}`
                  )
                }
              >
                <img
                  src={`https://njinternational.ilakshyaerp.in/uploads/student-tc/${item.cover}`}
                  alt=""
                />
                <br />
                <div className="life-overlay">
                  {
                    item.class_name
                  }
                </div>
              </div>
            )
          )}

        </div>

      </div>

      <Footer />
    </>
  );
};

export default StudentTcSession;